module.exports = __webpack_public_path__ + "img/4.4f14ffad.jpg";